import { render } from "./Privacy.vue?vue&type=template&id=153db236&scoped=true"
const script = {}

import "./Privacy.vue?vue&type=style&index=0&id=153db236&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\reino\\Desktop\\testt\\de-tol\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-153db236"]])

export default __exports__